import { DistributorReservationsTable } from '@/components/dashboard/ReservationsTables';
import StyledContainer from '@/components/styled/StyledContainer';
import StyledListHeader from '@/components/styled/StyledListHeader';
import { EstimateStatus } from '@/types/estimates/EstimateStatus';
import { useTranslation } from '@/i18n';

const EstimatesPage = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledListHeader
        title={t('estimates.title')}
        subTitle={t('pages.dashboard.estimatesInProgressDescription')}
      />
      <div className="flex flex-col w-full h-auto p-6 gap-6">
        <DistributorReservationsTable status={EstimateStatus.PENDING} />
      </div>
    </StyledContainer>
  );
};

export default EstimatesPage;
